import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { TUI_DARK_MODE } from '@taiga-ui/core';
import { tuiLikeOptionsProvider } from '@taiga-ui/kit';

import { ThemeSwitcherService } from '../../services/theme-switcher.service';

@Component({
  selector: 'app-theme-switcher-mini',
  templateUrl: './theme-switcher-mini.component.html',
  styleUrls: ['./theme-switcher-mini.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    tuiLikeOptionsProvider({
      icons: { unchecked: '@tui.sun', checked: '@tui.moon' },
    }),
  ],
})
export class ThemeSwitcherMiniComponent {
  private readonly themeSwitcherService = inject(ThemeSwitcherService);
  protected readonly darkMode = inject(TUI_DARK_MODE);

  isDark$ = this.themeSwitcherService.isDark$;

  onThemeChange(value: boolean) {
    this.themeSwitcherService.setTheme(!value);
  }
}
